"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/RecipientsRow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');




var _broadcast = require('shared/enum/broadcast');
var _phone = require('shared/services/phone');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Tooltip = require('web/components/Tooltip');
var _navigation = require('web/actions/navigation');

var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _Table = require('web/screens/Directory/PatientTable/Table');
var _useMessageCells = require('web/screens/Broadcast/RecipientTable/useMessageCells'); var _useMessageCells2 = _interopRequireDefault(_useMessageCells);
var _patientText = require('web/screens/Broadcast/Wizard/Recipients/patientText');


/* Rev 31 v2: a recipient that needs attention is skipped when the campaign
 * sends: no value and no default for a variable the message uses, or no
 * phone or email it can be sent to. */
 const needsAttention = (row) => row.Missing.length > 0 || !!row.Error; exports.needsAttention = needsAttention

/* Before anything is sent, a recipient's status says whether they'll get
 * the message (Ready), and if not, why. */
const DraftStatus = ({ row }) => {
  const [kind, label, why] = row.Error
    ? ['invalid', 'Invalid phone', 'No valid phone or email: this recipient is skipped when you send.']
    : row.Missing.length
      ? ['missing', 'Missing value', `No ${row.Missing.join(', ')} and no default: this recipient is skipped when you send.`]
      : ['ready', 'Ready', null]
  const pill = (
    _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'campaign--table--status-pill', `campaign--table--status-pill-${kind}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
      , _react2.default.createElement('span', { className: "campaign--table--status-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}},  label )
    )
  )
  return why
    ? _react2.default.createElement(_Tooltip.HoverTooltip, { type: "dark", place: "top", content: _react2.default.createElement('span', { className: "campaign--table--tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}},  why ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}},  pill )
    : pill
}

/* A variable's cell: the recipient's value; else what they get instead (the
 * default, in light-grey italic); else Missing (Rev 31 v2 table rules). */
const VariableCell = ({ column, row }) => {
  const value = row.Values[column.name]
  if (_optionalChain([value, 'optionalAccess', _ => _.trim, 'call', _2 => _2()])) return _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 46}},  value ))
  // Rev 32 V4: a recipient already messaged got the token's own fallback, if
  // any; a default set (or a variable added) since never reached them.
  if (isSent(row.Status)) {
    return (
      _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        ,  column.tokenFallback !== null
          ? _react2.default.createElement('span', { className: "campaign--table--value-default", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}},  column.tokenFallback )
          : _react2.default.createElement('span', { className: "campaign--table--value-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "—")
        
      )
    )
  }
  if (row.Missing.includes(column.name)) {
    return (
      _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
        , _react2.default.createElement('span', { className: "campaign--table--value-missing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Missing")
      )
    )
  }
  return (
    _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      ,  column.fallback !== null
        ? _react2.default.createElement('span', { className: "campaign--table--value-default", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  column.fallback )
        : _react2.default.createElement('span', { className: "campaign--table--value-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "—")
      
    )
  )
}

const isSent = (status) => status === _broadcast.broadcastMsgStatus.COMPLETED
  || status === _broadcast.broadcastMsgStatus.FAILED || status === _broadcast.broadcastMsgStatus.PROCESSING
  // Written to the chat already; only its text waits for consent.
  || status === _broadcast.broadcastMsgStatus.AWAITING_CONSENT

const displayName = (row) =>
  [row.FirstName, row.LastName].filter(Boolean).join(' ') || row.Phone || row.Email || 'Unnamed patient'














/* One recipient of the shared screen, as the campaign's recipients view
 * read it (re-read as messages go out). */
// D-58: an older server sends no tags; the cell shows a dash.
const NO_TAGS = []

const RecipientsRow = ({ campaign, row, columns, hasStarted, hasAddColumn, isSelected, onToggle, onEdit }) => {
  const key = _optionalChain([row, 'access', _3 => _3.Patient, 'optionalAccess', _4 => _4.PatientKey])
  const message = row.Status
    ? { Status: row.Status, ScheduledAt: row.ScheduledAt, SentAt: row.SentAt, ErrorCode: row.ErrorCode }
    : null
  const cells = _useMessageCells2.default.call(void 0, message)
  const name = row.Patient ? displayName(row) : 'Deleted patient'
  const isDraft = !hasStarted && (!message || message.Status === _broadcast.broadcastMsgStatus.NOT_SCHEDULED)
  const toggle = key && onToggle ? (b) => onToggle(key, b) : null

  return (
    _react2.default.createElement(_RecipientTable.RecipientRow, {
      className: _classBuilder2.default.call(void 0, isSelected && 'campaign--table--row--selected'),
      selection: toggle ? { isSelected, onToggle: toggle, label: `Select ${name}` } : null,
      onClick: toggle ? () => toggle(!isSelected) : undefined,
      avatarKey: _nullishCoalesce(key, () => ( name)),
      name: key
        ? (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement(_reactrouterdom.Link, {
                to: _navigation.makePatientPageRoute.call(void 0, campaign.OrgKey, key),
                className: "campaign--table--col-name--label",
                onClick: e => e.stopPropagation(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}

                ,  name 
              )
              , _react2.default.createElement('button', {
                type: "button",
                className: "recipients-row--edit",
                'aria-label': `Edit ${name}`,
                title: "Edit patient" ,
                onClick: e => {
                  e.stopPropagation()
                  onEdit(row)
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}

                , _react2.default.createElement('img', { src: "/assets/icons/header/edit-dark.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}} )
              )
            )
          )
        : name,
      dob: _patientText.formatDob.call(void 0, row.DOB),
      contact: (
        _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, row.Error && 'campaign--table--contact-invalid'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
          ,  _phone.formatPhoneNumber.call(void 0, row.Phone) || row.Phone || row.Email 
        )
      ),
      tags: _react2.default.createElement(_Table.PatientTags, { tags: _nullishCoalesce(row.Tags, () => ( NO_TAGS)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}} ),
      status: isDraft ? _react2.default.createElement(DraftStatus, { row: row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}} ) : cells.status,
      scheduledAt: cells.scheduledAt,
      sentAt: cells.sentAt,
      variableCells: columns.map(c => _react2.default.createElement(VariableCell, { key: c.name, column: c, row: row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}} )),
      hasTimes: hasStarted,
      hasTrailingCell: hasAddColumn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
    )
  )
}

exports. default = _react.memo.call(void 0, RecipientsRow)
